import axios from 'axios';

const API_BASE_URL = 'https://onecrmapi.oneaihuman.com/api/gmb';

export const uploadExcel = (file) => {
    const formData = new FormData();
    formData.append('excelFile', file);
    return axios.post(`${API_BASE_URL}/upload-excel`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const startImageUpload = (clientId = '') => {
    // Correctly routes to a specific client or all clients based on the parameter
    const url = clientId ? `${API_BASE_URL}/start-post-upload/${clientId}` : `${API_BASE_URL}/start-post-upload`;
    return axios.post(url);
};

export const getClients = () => {
    return axios.get(`${API_BASE_URL}/clients`);
};